import { Box } from '@frontend/components';

const Header = ({ boxRef, children }) => (
  <Box ref={boxRef} zIndex={11}>
    {children}
  </Box>
);

export default Header;
